// extracted by mini-css-extract-plugin
module.exports = {"labelSmall":"form-label_labelSmall__AB9vw"};